import {Component, inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {ImagesService} from '../../services/general/images.service';


@Component({
  selector: 'app-auth-layout',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent {

  _router = inject(Router);
  _images = inject(ImagesService);

  routeToDashboard() {
    this._router.navigate([''])
  }
}
